import pointStockEn from './point-stock/en.json';
import pointStockZhHant from './point-stock/zh-Hant.json';
import pointStockVi from './point-stock/vi.json';
import pointStockTh from './point-stock/th.json';

export default {
  en: pointStockEn,
  'zh-Hant': pointStockZhHant,
  vi: pointStockVi,
  th: pointStockTh,
};
